import React from 'react'
import useMakeRequest from '../../utils/ApiHelper';
import toast from 'react-hot-toast';
import { ApiConstants } from '../../constants/ApiConstants';

interface LogoutProps {
    toggleModal: () => void;
    handleLogout: () => void;
}

const Logout: React.FC<LogoutProps> = ({ toggleModal, handleLogout }) => {
    const logout = useMakeRequest();

    const onLogout = () => {
        toast.promise(
            logout.makeRequest({ url: ApiConstants?.Logout }),
            {
                loading: 'Logging out...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        ).then(() => {
            handleLogout();
            toggleModal();
        })
    }

    const modalRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        const previouslyFocusedElement = document.activeElement as HTMLElement;

        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                toggleModal();
                return;
            }
            if (e.key === 'Tab' && modalRef.current) {
                const focusableElements = modalRef.current.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex="0"]'
                );
                if (focusableElements.length === 0) return;

                const firstElement = focusableElements[0] as HTMLElement;
                const lastElement = focusableElements[focusableElements.length - 1] as HTMLElement;

                if (e.shiftKey) {
                    if (document.activeElement === firstElement) {
                        lastElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        firstElement.focus();
                        e.preventDefault();
                    }
                }
            }
        };

        if (modalRef.current) {
            const focusableElements = modalRef.current.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex="0"]'
            );
            if (focusableElements.length > 0) {
                (focusableElements[0] as HTMLElement).focus();
            }
        }

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
                previouslyFocusedElement.focus();
            }
        };
    }, [toggleModal]);

    return (
        <div className='custom-modal'>
            <div className='custom-modal-backdrop' onClick={toggleModal} aria-hidden="true"></div>
            <div
                ref={modalRef}
                className='custom-modal-body'
                role="dialog"
                aria-modal="true"
                aria-labelledby="logout-modal-title"
            >
                <div id="logout-modal-title" className='logout-txt'>Are you sure you would like to logout?</div>

                <div className='custom-modal-foot'>
                    <button className='custom-modal-btn modal-light-btn' onClick={toggleModal}>Cancel</button>
                    <button className='custom-modal-btn modal-dark-btn' onClick={onLogout}>Confirm</button>
                </div>
            </div>
        </div>
    )
}


export default Logout
